import React from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Calendar } from "../../assets/icons/Calendar.svg";
import { ReactComponent as Chevron } from "../../assets/icons/chevron-left.svg";
import PhoneHeader from "../../Components/Common/PhoneHeader";
const moment = require("moment-jalaali");
moment.loadPersian({ dialect: "persian-modern" });
const data = [
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 2, created_at: moment() },
];

function Messages() {
  const history = useHistory();
  return (
    <div className="Container" id="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          overflowY: "scroll",
          paddingBottom: window.innerHeight * 0.15,
        }}
      >
        <PhoneHeader text={"پیام ها"} />
        {data?.map((item) => {
          return (
            <div
              className="MessagesComponent"
              onClick={() =>
                history.push({ pathname: "MessagesSingle", state: item })
              }
            >
              <div>
                <div className="StartDiv">
                  <span>{item?.title}</span>
                </div>
                <div className="divider" />
                <div className="StartDiv">
                  <div className="StartDiv">
                    <Calendar />
                    <span className="dateSpan" style={{ marginRight: 5 }}>
                      {moment(item?.created_at).format("jYYYY/jMM/jDD")}
                    </span>
                  </div>
                </div>
              </div>
              <Chevron />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Messages;
